<script>
    import Posts from '~/components/Posts.svelte';
    import { slide } from 'svelte/transition';

    export let tagString;

    $: tags = tagString.split(';').map(x => x.trim());
</script>

{#if tags.length === 0}
    <p transition:slide={{duration: 200}}>Thought you could visit a tags page without any specifying any tags? Think again!</p>
{:else if tags.length > 10}
    <p transition:slide={{duration: 200}}>Too many tags, too little database support!</p>
{:else}
    <Posts title="Tagged {tags.join(' | ')}" {tags} />
{/if}
